import { ICreateMaintenanceComment, IUpdateMaintenanceComment } from '@/interfaces/api/maintenanceComment'
import ApiService from '../api.service'

const MaintenanceCommentResource = {
    getMaintenanceCommentsPages : (
        page: number,
        items: number,
        sort: string,
        sort_direction: string,
        maintenance_id: string
    ) =>
        ApiService.get(
            `/v1/maintenance_comments?page=${page}&items=${items}&sort=${sort}&sort_direction=${sort_direction}&maintenance_id=${maintenance_id}`,
    ),
    createMaintenanceComment: (params: ICreateMaintenanceComment) => ApiService.post('/v1/maintenance_comments', params),
    updateMaintenanceComment: (id: number, params: IUpdateMaintenanceComment) => ApiService.put(`/v1/maintenance_comments/${id}`, params),
    deleteMaintenanceComment: (id: number) => ApiService.delete(`/v1/maintenance_comments/${id}`),
}

export default MaintenanceCommentResource